// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-lazy-image[data-v-fdc73694]{opacity:.5;transition:all 1s}.v-lazy-image-loaded[data-v-fdc73694]{opacity:1}", ""]);
// Exports
module.exports = exports;
